module.exports = __webpack_public_path__ + "img/golang-http.6f7d5104.png";